/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminPlayerRestriction } from './AdminPlayerRestriction';
import {
    AdminPlayerRestrictionFromJSON,
    AdminPlayerRestrictionFromJSONTyped,
    AdminPlayerRestrictionToJSON,
} from './AdminPlayerRestriction';

/**
 * 
 * @export
 * @interface FraudRestrictionsAdminPage
 */
export interface FraudRestrictionsAdminPage {
    /**
     * 
     * @type {Array<AdminPlayerRestriction>}
     * @memberof FraudRestrictionsAdminPage
     */
    restrictions: Array<AdminPlayerRestriction>;
    /**
     * 
     * @type {number}
     * @memberof FraudRestrictionsAdminPage
     */
    totalResults: number;
    /**
     * 
     * @type {number}
     * @memberof FraudRestrictionsAdminPage
     */
    resultEnd: number;
    /**
     * 
     * @type {number}
     * @memberof FraudRestrictionsAdminPage
     */
    resultStart: number;
}

/**
 * Check if a given object implements the FraudRestrictionsAdminPage interface.
 */
export function instanceOfFraudRestrictionsAdminPage(value: object): value is FraudRestrictionsAdminPage {
    if (!('restrictions' in value) || value['restrictions'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    if (!('resultEnd' in value) || value['resultEnd'] === undefined) return false;
    if (!('resultStart' in value) || value['resultStart'] === undefined) return false;
    return true;
}

export function FraudRestrictionsAdminPageFromJSON(json: any): FraudRestrictionsAdminPage {
    return FraudRestrictionsAdminPageFromJSONTyped(json, false);
}

export function FraudRestrictionsAdminPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): FraudRestrictionsAdminPage {
    if (json == null) {
        return json;
    }
    return {
        
        'restrictions': ((json['restrictions'] as Array<any>).map(AdminPlayerRestrictionFromJSON)),
        'totalResults': json['totalResults'],
        'resultEnd': json['resultEnd'],
        'resultStart': json['resultStart'],
    };
}

export function FraudRestrictionsAdminPageToJSON(value?: FraudRestrictionsAdminPage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'restrictions': ((value['restrictions'] as Array<any>).map(AdminPlayerRestrictionToJSON)),
        'totalResults': value['totalResults'],
        'resultEnd': value['resultEnd'],
        'resultStart': value['resultStart'],
    };
}

